import { EventEmitter } from '@angular/core';
import { CommonService } from '../common.service';
var AppMentorGuideComponent = (function () {
    function AppMentorGuideComponent(commonService) {
        this.commonService = commonService;
        this.assetsRoute = '../assets';
        this.outPutMenuClick = new EventEmitter();
        this.isShowItem = false;
        this.isScorm = false;
    }
    AppMentorGuideComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (localStorage.getItem('source_env') === 'LMS_SCORM') {
            this.isScorm = true;
            return;
        }
        if (this.pageLoaded) {
            setTimeout(function () {
                _this.isShowItem = true;
            }, 1000);
        }
    };
    AppMentorGuideComponent.prototype.clickMenu = function () {
        var _this = this;
        if (this.commonService.isMentorGuideDebugMode()) {
            this.outPutMenuClick.emit();
            return;
        }
        this.commonService.setOnceIno(this.commonService.MENTOR_GUIDE_ONCE_VALUE).subscribe(function () {
            _this.outPutMenuClick.emit();
        });
    };
    return AppMentorGuideComponent;
}());
export { AppMentorGuideComponent };



// WEBPACK FOOTER //
// ./src/app/app-mentor-guide/app-mentor-guide.component.ts.pre-build-optimizer.js